<template>
  <div>
    Loading....
  </div>
</template>
<script>
// import request from '@/utils/request'
export default {
  created() {
    this.$router.push('/store/index')
    // request({
    //   url: '/user/Login',
    //   method: 'post'
    // }).then(Response => {
    //   this.$router.push('/store/index?system=' + id)
    // })
  }

}
</script>
